(() => {
  'use strict';
  if (window.roselunoProductGalleryLoaded) return;
  window.roselunoProductGalleryLoaded = true;
  const scrollBehavior = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  const init = (scope = document) => {
    scope.querySelectorAll('[data-ritual-gallery]').forEach((gallery) => {
      if (gallery.dataset.galleryInitialized) return;
      const track = gallery.querySelector('[data-product-gallery]');
      const slides = Array.from(track.querySelectorAll('[data-gallery-slide]'));
      const images = slides.filter((slide) => slide.dataset.mediaType === 'image');
      const count = gallery.querySelector('[data-gallery-current]');
      const zoom = gallery.querySelector('[data-gallery-zoom]');
      const dialog = gallery.querySelector('[data-gallery-dialog]');
      const dialogImage = dialog.querySelector('[data-gallery-dialog-image]');
      const dialogCount = dialog.querySelector('[data-gallery-dialog-count]');
      let current = 0;
      let zoomIndex = 0;
      let previousBodyOverflow;
      let pendingFrame;
      gallery.dataset.galleryInitialized = 'true';
      const indexFromTrack = () => Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / (track.clientWidth || 1))));
      const update = () => {
        current = indexFromTrack();
        count.textContent = String(current + 1);
        zoom.hidden = !slides[current] || slides[current].dataset.mediaType !== 'image' || typeof dialog.showModal !== 'function';
        slides.forEach((slide, index) => {
          if (index === current) return;
          slide.querySelectorAll('video').forEach((video) => video.pause());
        });
      };
      const go = (index) => {
        const next = (index + slides.length) % slides.length;
        track.scrollTo({ left: next * track.clientWidth, behavior: scrollBehavior() });
      };
      const updateDialog = () => {
        const slide = images[zoomIndex];
        if (!slide) return;
        dialogImage.src = slide.dataset.zoomSrc;
        dialogImage.alt = slide.dataset.zoomAlt || '';
        dialogCount.textContent = `${zoomIndex + 1} of ${images.length}`;
        dialog.querySelectorAll('[data-gallery-dialog-step]').forEach((button) => { button.hidden = images.length < 2; });
      };
      gallery.addEventListener('click', (event) => {
        const step = event.target.closest('[data-gallery-step]');
        if (step) { go(indexFromTrack() + Number(step.dataset.galleryStep)); return; }
        if (event.target.closest('[data-gallery-zoom]')) {
          zoomIndex = images.indexOf(slides[indexFromTrack()]);
          if (zoomIndex < 0 || typeof dialog.showModal !== 'function') return;
          updateDialog();
          previousBodyOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          dialog.showModal();
          dialog.querySelector('[data-gallery-close]').focus();
        }
      });
      track.addEventListener('scroll', () => {
        if (pendingFrame) cancelAnimationFrame(pendingFrame);
        pendingFrame = requestAnimationFrame(update);
      }, { passive: true });
      track.addEventListener('keydown', (event) => {
        if (event.target !== track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          go(indexFromTrack() + (event.key === 'ArrowLeft' ? -1 : 1));
        }
      });
      dialog.addEventListener('click', (event) => {
        if (event.target.closest('[data-gallery-close]') || event.target === dialog) { dialog.close(); return; }
        const step = event.target.closest('[data-gallery-dialog-step]');
        if (step) { zoomIndex = (zoomIndex + Number(step.dataset.galleryDialogStep) + images.length) % images.length; updateDialog(); }
      });
      dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        zoomIndex = (zoomIndex + (event.key === 'ArrowLeft' ? -1 : 1) + images.length) % images.length;
        updateDialog();
      });
      dialog.addEventListener('close', () => { document.body.style.overflow = previousBodyOverflow || ''; zoom.focus({ preventScroll: true }); });
      window.addEventListener('resize', () => { track.scrollTo({ left: current * track.clientWidth, behavior: 'auto' }); update(); }, { passive: true });
      const section = gallery.closest('[data-product-section]');
      const select = section && section.querySelector('[data-variant-select]');
      if (select) {
        const initial = select.selectedOptions[0];
        const initialIndex = initial && slides.findIndex((slide) => slide.id === initial.dataset.media);
        if (initialIndex > 0) track.scrollTo({ left: initialIndex * track.clientWidth, behavior: 'auto' });
      }
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
